import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Default404Component } from './Default404Component';
import { defaultTitle, defaultText } from './content';
/**
 * Premade 404 **page** with a pretty graphic.
 *
 * > Note: Has defaults for children and title, but can be overridden
 */
export const Default404Page = ({ title = defaultTitle, children = defaultText, }) => {
    useEffect(() => {
        document.title = title;
    }, [title]);
    return _jsx(Default404Component, Object.assign({ title: title }, { children: children }));
};
